module.exports = {"fb_pixel_id":"1244488155706166"}


//////////////////
// WEBPACK FOOTER
// ./src/config/constants.json
// module id = 639
// module chunks = 0